import { ShoppingCart, Coffee, Activity, Layers } from 'lucide-react';

const industries = [
    {
        icon: ShoppingCart,
        title: "Mercados & Varejo",
        description: "Automatize ofertas, gerencie preços dinamicamente e impulsione vendas por impulso.",
        color: "bg-blue-50 text-blue-600"
    },
    {
        icon: Coffee,
        title: "Restaurantes & Cafés",
        description: "Digitalize seu menu, destaque o prato do dia e crie um ambiente moderno e apetitoso.",
        color: "bg-orange-50 text-orange-600"
    },
    {
        icon: Activity,
        title: "Clínicas & Consultórios",
        description: "Informe sobre procedimentos e promova a saúde de forma visual.",
        color: "bg-teal-50 text-teal-600"
    },
    {
        icon: Layers,
        title: "E muito mais",
        description: "Farmácias, Academias, Hotéis, Salões de Beleza...",
        color: "bg-purple-50 text-purple-600"
    }
];

export const LandingIndustries = () => {
    return (
        <section className="py-24 bg-gray-50">
            <div className="max-w-[1440px] mx-auto px-6">
                <div className="text-center mb-16">
                    <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6">
                        A Solução Ideal para o <span className="text-primary">Empreendedor Moderno</span>
                    </h2>
                    <p className="text-xl text-gray-500 max-w-2xl mx-auto font-medium">
                        Potencialize a comunicação em qualquer ambiente comercial, do pequeno café à grande rede de supermercados.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {industries.map((item, index) => (
                        <div key={index} className="bg-white p-8 rounded-[32px] hover:shadow-xl transition-shadow border border-gray-100">
                            <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-6 ${item.color}`}>
                                <item.icon className="w-7 h-7" />
                            </div>
                            <h3 className="text-xl font-black text-gray-900 mb-3">{item.title}</h3>
                            <p className="text-gray-500 font-medium leading-relaxed">
                                {item.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
